"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var AdPersona = /** @class */ (function (_super) {
    tslib_1.__extends(AdPersona, _super);
    function AdPersona() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdPersona.prototype.render = function () {
        return (React.createElement(Persona_1.Persona, { size: Persona_1.PersonaSize.regular, primaryText: this.props.name, imageUrl: this.props.imageUrl }));
    };
    AdPersona = tslib_1.__decorate([
        mobx_react_1.observer
    ], AdPersona);
    return AdPersona;
}(React.Component));
exports.default = AdPersona;
//# sourceMappingURL=AdPersona.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/components/AdPersona.js
// module id = 5557
// module chunks = 17